<template>
    <div class="confirmation-form">
        <panel-competition-form-box class="confirmation-form__box mab16">
            <div class="col-12 col-lg-8">
                <panel-input-area
                    ref="messageArea"
                    v-model="content"
                    label="Treść e-maila z potwierdzeniem rejestracji"
                    :rows="12"
                />
            </div>
            <div class="col-12 col-lg-4">
                <div class="confirmation-form__container">
                    <base-button
                        btn2
                        short
                        class="confirmation-form__test"
                        icon="fas fa-envelope"
                        :loading="sendingTest"
                        :disabled="saving || sendingTest"
                        @click="onSendTest"
                    >
                        Wyślij na własny adres
                    </base-button>
                    <p class="tags-title mat24">Znaczniki personalizacji</p>
                    <p class="tags-desc">Kliknij znacznik, aby wstawić go do treści:</p>
                    <ul class="tags-list">
                        <li v-for="tag in availableTags" :key="tag.key">
                            <button type="button" class="tag-btn" @click="insertTag(tag.key)">[{{ tag.key }}]</button>
                            <span class="tag-label">{{ tag.label }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </panel-competition-form-box>

        <div class="confirmation-form__actions mat24 mab24">
            <base-button btn1 :loading="saving" :disabled="saving || sendingTest" @click="onSave">Zapisz</base-button>
        </div>
    </div>
</template>

<script>
    import PanelCompetitionFormBox from '@/components/PanelCompetitionFormBox';
    import PanelInputArea from '@/components/PanelInputArea';

    export default {
        name: 'PanelCompetitionConfirmationForm',
        components: {
            PanelCompetitionFormBox,
            PanelInputArea,
        },
        props: {
            value: {
                type: String,
                default: '',
            },
            saving: {
                type: Boolean,
                default: false,
            },
            sendingTest: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                availableTags: [
                    { key: 'firstname', label: 'imię' },
                    { key: 'lastname', label: 'nazwisko' },
                    { key: 'date', label: 'data startu' },
                    { key: 'time', label: 'godzina startu' },
                    { key: 'classification', label: 'klasyfikacja' },
                    { key: 'category', label: 'kategoria' },
                    { key: 'regulations', label: 'link do regulaminu' },
                ],
            };
        },
        computed: {
            content: {
                get() {
                    return this.value || '';
                },
                set(next) {
                    this.$emit('input', next == null ? '' : String(next));
                },
            },
        },
        methods: {
            insertTag(key) {
                const tag = `[${key}]`;
                const textarea = this.$refs.messageArea?.$el?.querySelector('textarea');
                if (textarea) {
                    const start = textarea.selectionStart ?? textarea.value.length;
                    const end = textarea.selectionEnd ?? textarea.value.length;
                    const current = this.content;
                    this.content = current.slice(0, start) + tag + current.slice(end);
                    this.$nextTick(() => {
                        textarea.focus();
                        const newPos = start + tag.length;
                        textarea.setSelectionRange(newPos, newPos);
                    });
                } else {
                    this.content += tag;
                }
            },
            onSave() {
                this.$emit('save');
            },
            onSendTest() {
                this.$emit('send-test');
            },
        },
    };
</script>

<style scoped>
    .confirmation-form {
        width: 100%;
    }
    .confirmation-form .form.confirmation-form__box {
        padding: 24px 16px;
        overflow: visible;
    }
    .confirmation-form__test {
        margin-top: 24px;
    }
    .tags-title {
        font-family: 'Bariol Bold';
        font-size: 14px;
    }
    .tags-desc {
        font-size: 12px;
        /* color: var(--color-bluish-grey); */
        margin-top: 4px;
        margin-bottom: 8px;
    }
    .tags-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .tags-list li {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .tag-btn {
        background: var(--color-pale-grey);
        border: 1px solid var(--color-silver);
        border-radius: 4px;
        padding: 2px 8px;
        font-size: 12px;
        color: var(--color-slate);
        cursor: pointer;
        font-family: monospace;
        transition: background 0.15s, border-color 0.15s;
        flex-shrink: 0;
    }
    .tag-btn:hover {
        background: var(--color-silver);
        border-color: var(--color-cool-grey);
    }
    .tag-label {
        font-size: 12px;
        /* color: var(--color-bluish-grey); */
    }
    .confirmation-form__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: flex-end;
        align-items: center;
    }
    @media (min-width: 992px) {
        .confirmation-form .form.confirmation-form__box {
            padding: 24px 32px;
        }
        .confirmation-form__test {
            margin-top: 0;
        }
        .confirmation-form__container {
            margin-left: 16px;
        }
    }
</style>
